const notification = [
  {
    path: '/notification/list',  // 消息
    name: 'notificationList',
    component: () => import('@/pages/notification/list/index.vue'),
  },
  {
    path: '/notification/messageDetail',  // 通知详情
    name: '/notification/messageDetail',
    component: () => import('@/pages/notification/list/messageDetail.vue'),
  },

  {
    path: '/notification/handleDetail',  // 待办详情
    name: '/notification/handleDetail',
    component: () => import('@/pages/notification/list/handleDetail.vue'),
  },
  {
    path: '/notification/config',  // 设置
    name: '/notification/config',
    component: () => import('@/pages/notification/config/index.vue'),
  },
  {
    path: '/notification/login',  // 微信登录
    name: '/notification/login',
    component: () => import('@/pages/notification/login/index.vue'),
  },
  {
    path: '/notification/login/login',  // 手机号登录
    name: '/notification/login/login',
    component: () => import('@/pages/notification/login/login.vue'),
  },
  {
    path: '/notification/login/compoents/agreement',  // 登录协议
    name: '/notification/login/compoents/agreement',
    component: () => import('@/pages/notification/login/compoents/agreement.vue'),
  },
  {
    path: '/notification/login/compoents/policy',  // 登录协议
    name: '/notification/login/compoents/policy',
    component: () => import('@/pages/notification/login/compoents/policy.vue'),
  },
]
export default notification


// WEBPACK FOOTER //
// ./src/router/modules/notification.js